import { render, staticRenderFns } from "./SystemCallNumChartsPage.vue?vue&type=template&id=6f6b6916&scoped=true&"
import script from "./SystemCallNumChartsPage.vue?vue&type=script&lang=js&"
export * from "./SystemCallNumChartsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b6916",
  null
  
)

export default component.exports